export default __webpack_public_path__ + "static/media/w8.cebc5f20.jpg";